export const handleUrlException = (url) => {
    switch (url) {
        case "winner11":
        case "winner12":
        case "winner13":
        case "winner14":
        case "winner15":
        case "winner16":
        case "winner17":
        case "winner18":
        case "winner19":
        case "winner20":
        case "winner21":
        case "winner22":
        case "winner23":
        case "winner24":
        case "winner25":
        case "winner26":
        case "winner27":
        case "winner28":
        case "winner29":
        case "winner30":
        case "winner31":
        case "winner32":
        case "winner33":
        case "winner34":
        case "winner35":
        case "winner36":
        case "winner37":
        case "winner38":
        case "winner39":
        case "winner40":
            return false;

        default:
            return true;
    }
};
